/**
 * **WARNING** This is not an exhaustive list!
 *
 * All MSAL error codes we know of so far.
 */
export var MsalAuthErrorCode;
(function (MsalAuthErrorCode) {
    MsalAuthErrorCode["user_cancelled"] = "user_cancelled";
    MsalAuthErrorCode["block_iframe_reload"] = "block_iframe_reload";
    MsalAuthErrorCode["no_tokens_found"] = "no_tokens_found";
    MsalAuthErrorCode["no_account_error"] = "no_account_error";
    MsalAuthErrorCode["state_not_found"] = "state_not_found";
    MsalAuthErrorCode["interaction_required"] = "interaction_required";
    MsalAuthErrorCode["login_required"] = "login_required";
    MsalAuthErrorCode["access_denied"] = "access_denied";
    MsalAuthErrorCode["consent_required"] = "consent_required";
    MsalAuthErrorCode["invalid_grant"] = "invalid_grant";
    MsalAuthErrorCode["monitor_window_timeout"] = "monitor_window_timeout";
})(MsalAuthErrorCode || (MsalAuthErrorCode = {}));
